import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "122",
  height: "122",
  fill: "none",
  viewBox: "0 0 122 122"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M25.29 57.914a5.156 5.156 0 0 1 5.181-5.156l8.59.028a5.164 5.164 0 0 1 5.164 5.164v32.48c.967-.287 2.209-.593 3.568-.913a4.3 4.3 0 0 0 3.317-4.187V45.04a5.165 5.165 0 0 1 5.164-5.165h8.607a5.165 5.165 0 0 1 5.164 5.165v37.393s2.155-.872 4.254-1.758a4.312 4.312 0 0 0 2.632-3.967V32.13a5.164 5.164 0 0 1 5.163-5.164H90.7a5.164 5.164 0 0 1 5.164 5.164v36.709c7.462-5.408 15.024-11.912 21.025-19.733a8.661 8.661 0 0 0 1.319-8.092A60.79 60.79 0 0 0 15.361 20.577a60.789 60.789 0 0 0-7.284 70.67 7.688 7.688 0 0 0 7.334 3.8c1.628-.142 3.655-.345 6.065-.628a4.3 4.3 0 0 0 3.815-4.27l-.001-32.235Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M25.102 110.009a60.813 60.813 0 0 0 63.371 5.013 60.816 60.816 0 0 0 33.212-54.203c0-1.4-.065-2.785-.158-4.162-22.219 33.138-63.244 48.63-96.423 53.347"
    }, null, -1)
  ])))
}
export default { render: render }